import { MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import {
  useMutation,
  useListContext,
  sanitizeFetchType,
  useNotify,
  useTranslate,
} from 'react-admin'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { BulkActionProps } from '../../../common/BulkActionsProps'
import { DepositorEventsRecurringDialog } from '../DepositorDialogs'
import { DepositorDto } from '../../../../core/dto/device/depositor/depositor.dto'
import { DateTime } from '../../../../core/common/date-time'

export const DepositorsAttachEventRecurringBulkButton = ({
  selectedIds,
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  innerRef,
  eventAction,
  ...props
}: BulkActionProps & { eventAction: 'attach' | 'detach' }) => {
  const { loading, refetch } = useListContext<DepositorDto>()
  const notify = useNotify()
  const translate = useTranslate()
  const hasAuthority = useHasAuthority()
  const [selectStateDialogOpen, setSelectStateDialogOpen] = useState(false)
  const [mutate, { loading: mutationLoading }] = useMutation()
  const [eventId, setEventId] = useState<number | undefined>()

  const handleMutation = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    const query = {
      type: sanitizeFetchType(`${eventAction}Devices`),
      resource: ResourceName.EVENTS,
      payload: {
        eventId,
        verifierDevicesIds: selectedIds,
        recurringJobName,
        cronExpression,
        scheduledAt,
      },
    }
    const result = await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    return result
  }

  const handleAttachEvents = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    setSelectStateDialogOpen(false)
    handleMutation(recurringJobName, cronExpression, scheduledAt)
    refetch()
  }

  const handleDialogClose = () => {
    setSelectStateDialogOpen(false)
  }

  return (
    <MenuItem
      {...props}
      disabled={
        !selectedIds.length ||
        !hasAuthority(Authority.EDIT_DEPOSITORS) ||
        loading ||
        mutationLoading
      }
      onClick={() => setSelectStateDialogOpen(true)}
      button
    >
      <Typography>
        {translate(
          `resources.depositors.actions.${eventAction}Events-recurring`,
        )}
      </Typography>
      <DepositorEventsRecurringDialog
        open={selectStateDialogOpen}
        close={handleDialogClose}
        setSelectedEventId={setEventId}
        handleAttachment={handleAttachEvents}
        method={eventAction}
      />
    </MenuItem>
  )
}
